import React from 'react';
import { Modal, Button } from 'components/common';
import PropTypes from 'prop-types';
import { useDispatch } from "react-redux";
import { FiAlertTriangle } from 'react-icons/fi';
import { toast } from "react-toastify";
import { deleteFaq } from "redux/documentation/faqSlice";

const FaqDeleteConfirmation = ({ showModal, setshowModal, faq }) => {
  const dispatch = useDispatch();

  const closeModal = () => {
    setshowModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await dispatch(deleteFaq(faq.id));
      toast.success('FAQ deleted successfully');
      closeModal();
    } catch (error) {
      toast.error(error.message || 'Failed to delete FAQ');
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      title="Delete FAQ"
      width="400px"
    >
      <form onSubmit={handleSubmit}>
        <div className="tw-space-y-4">
          {/* Alert Box */}
          <div className="tw-flex tw-items-start tw-gap-3 tw-p-4 tw-bg-red-50 tw-border tw-border-red-200 tw-rounded">
            <FiAlertTriangle className="tw-text-red-600 tw-flex-shrink-0 tw-mt-0.5" size={20} />
            <div>
              <p className="tw-text-sm tw-font-semibold tw-text-red-900">Delete FAQ?</p>
              <p className="tw-text-sm tw-text-red-800 tw-mt-1">
                You're about to delete <strong>&ldquo;{faq.title}&rdquo;</strong>. This action cannot be undone.
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="tw-flex tw-items-center tw-justify-end tw-gap-3 tw-mt-6 tw-pt-4 tw-border-t tw-border-slate-200">
          <Button variant="ghost" onClick={closeModal} size="sm">
            Cancel
          </Button>
          <Button variant="danger" type="submit" size="sm">
            Delete FAQ
          </Button>
        </div>
      </form>
    </Modal>
  );
};

FaqDeleteConfirmation.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired,
  faq: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    title: PropTypes.string.isRequired
  }).isRequired
};

export default FaqDeleteConfirmation;
